const HASHTAG_FEED_KEY_PREFIX = "hashtag:";
const TEAM_FEED_KEY_PREFIX = "team:";

function getRaceEntries(userRaces) {
  if (userRaces instanceof Map) return Array.from(userRaces.entries());
  if (Array.isArray(userRaces)) return userRaces.map((race) => [race?.legId, race]);
  if (userRaces && typeof userRaces === "object") return Object.entries(userRaces);
  return [];
}

function buildTeamFeedKey({ raceId, legId, teamName }) {
  return `${TEAM_FEED_KEY_PREFIX}${raceId}:${legId}:${teamName}`;
}

function getActiveTeamFeedFilters(userRaces, nowMs = Date.now()) {
  const filters = new Map();

  getRaceEntries(userRaces).forEach(([fallbackLegId, race]) => {
    const teamName = typeof race?.teamName === "string" ? race.teamName.trim() : "";
    if (!teamName || teamName === "noTeam") return;

    const raceEndMs = new Date(race?.raceInfo?.raceDateEnd).getTime();
    if (!Number.isFinite(raceEndMs) || raceEndMs < nowMs) return;

    const raceId = race?.raceId;
    const legId = race?.legId || fallbackLegId;
    if (!raceId || !legId) return;

    const key = buildTeamFeedKey({ raceId, legId, teamName });
    if (filters.has(key)) return;

    filters.set(key, {
      key,
      label: teamName,
      raceId,
      legId,
      teamName,
      raceName: race?.raceInfo?.name || "",
    });
  });

  return Array.from(filters.values());
}

function getPostFeedFilterKeys(hashtags = [], userRaces, nowMs = Date.now()) {
  const hashtagKeys = hashtags
    .filter((hashtag) => typeof hashtag === "string" && hashtag.length > 0)
    .map((hashtag) => `${HASHTAG_FEED_KEY_PREFIX}${hashtag}`);

  const teamKeys = getActiveTeamFeedFilters(userRaces, nowMs).map((filter) => filter.key);

  return Array.from(new Set([...hashtagKeys, ...teamKeys]));
}

export { getActiveTeamFeedFilters, getPostFeedFilterKeys };
